export default __webpack_public_path__ + "static/media/trylleby-property-23.fd45371d.jpg";